var Bar = /** @class */ (function () {
    function Bar(x, y, width, height, color, index) {
        this._x = x;
        this._y = y;
        this._width = width;
        this._height = height;
        this._color = color;
        this._angle = index;
    }
    Bar.prototype.update = function (microphoneValue) {
        var sound = microphoneValue * 1000;
        if (sound > this._height) {
            this._height = sound;
        }
        else {
            this._height -= this._height * 0.05;
        }
    };
    Bar.prototype.draw = function (canvasContext, volume) {
        canvasContext.strokeStyle = this._color;
        canvasContext.save();
        canvasContext.translate(0, 0);
        canvasContext.rotate(this._angle * 0.05);
        canvasContext.scale(1 + volume * 0.2, 1 + volume * 0.2);
        canvasContext.beginPath();
        canvasContext.moveTo(this._x, this._y);
        canvasContext.lineTo(this._y, this._height);
        canvasContext.stroke();
        canvasContext.strokeRect(this._x, this._y, this._width, this._height);
        canvasContext.restore();
    };
    return Bar;
}());
export { Bar };
